import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Temporadas.css';
import { useAuth } from '../../context/AuthContext';
import { getTemporadasReal, crearTemporada, borrarTemporada, cambiarVisibilidadTemporada } from '../../services/temporadasService';

const ESTADO_ORDEN = { PLANIFICADA: 0, INICIADA: 1, FINALIZADA: 2 };

// La visibilidad que controla el botón: ADMIN decide la de comité (y, con
// ella, jugador y público); COMITE decide la de jugador (y público).
const visibleParaMiNivel = (t, rol) =>
  rol === 'ADMIN' ? t.visible_rol_comite : t.visible_rol_jugador;

export default function TemporadasList() {
  const [temporadas, setTemporadas] = useState([]);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [nombre, setNombre] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { usuario } = useAuth();

  const cargar = () => getTemporadasReal().then(ts =>
    setTemporadas([...ts].sort((a, b) => ESTADO_ORDEN[a.estado] - ESTADO_ORDEN[b.estado]))
  );

  useEffect(() => { cargar(); }, []);

  const crear = async (e) => {
    e.preventDefault();
    if (!nombre.trim()) return;
    setError(null);
    try {
      await crearTemporada({ nombre: nombre.trim(), fechaInicio: fechaInicio || undefined });
      setNombre(''); setFechaInicio(''); setMostrarForm(false);
      cargar();
    } catch (err) {
      setError(err.message || 'Error al crear la temporada.');
    }
  };

  const alternarVisibilidad = async (t) => {
    setError(null);
    try {
      await cambiarVisibilidadTemporada(t.id, !visibleParaMiNivel(t, usuario?.rol));
      cargar();
    } catch (err) {
      setError(err.message || 'No se pudo cambiar la visibilidad.');
    }
  };

  const borrar = async (id, estado) => {
    if (estado !== 'PLANIFICADA') { alert('Solo se pueden borrar temporadas en estado PLANIFICADA.'); return; }
    if (!window.confirm(`¿Borrar la temporada "${id}"? Se borrarán también sus jornadas y participantes.`)) return;
    await borrarTemporada(id);
    cargar();
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Temporadas</h2>
        <button className="btn btn-primary" onClick={() => setMostrarForm(v => !v)}>
          {mostrarForm ? 'Cancelar' : '+ Nueva temporada'}
        </button>
      </div>

      {mostrarForm && (
        <form className="nueva-form" onSubmit={crear} style={{ marginBottom: '1.5rem' }}>
          <label>
            Nombre (ej: 2025-2026)
            <input value={nombre} onChange={e => setNombre(e.target.value)} placeholder="2025-2026" required />
          </label>
          <label>
            Fecha de inicio
            <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
          </label>
          <button type="submit" className="btn btn-primary">Crear</button>
        </form>
      )}

      {error && <p className="error-msg">{error}</p>}

      <div className="temporadas-grid">
        {temporadas.map(t => {
          const visible = visibleParaMiNivel(t, usuario?.rol);
          const destino = usuario?.rol === 'ADMIN' ? 'comité, jugadores y público' : 'jugadores y público';
          const titulo = visible ? `Ocultar temporada para ${destino}` : `Mostrar temporada a ${destino}`;
          return (
          <div key={t.id} className="temporada-card">
            <h3>{t.nombre}</h3>
            <span className={`badge-estado badge-${t.estado}`}>{t.estado}</span>
            {!visible && <span style={{ fontSize: '.78rem', color: '#888' }}>Oculta en el selector</span>}
            {t.fecha_inicio && <span style={{ fontSize: '.78rem', color: '#888' }}>Inicio: {t.fecha_inicio}</span>}
            <div className="card-actions">
              <button className="prim" onClick={() => navigate(`/dashboard/temporadas/${t.id}`)}>Gestionar</button>
              <button
                className={`icono${visible ? '' : ' oculta'}`}
                title={titulo}
                aria-label={titulo}
                onClick={() => alternarVisibilidad(t)}
              >
                {visible ? '👁️' : '🚫'}
              </button>
              {t.estado === 'PLANIFICADA' && (
                <button className="danger" onClick={() => borrar(t.id, t.estado)}>Borrar</button>
              )}
            </div>
          </div>
          );
        })}
        {!temporadas.length && <p className="info-msg">No hay temporadas. Crea una para empezar.</p>}
      </div>
    </div>
  );
}
